<template>
  <div>
    <date-label
      v-if="data.article.issueDate"
      :date="data.article.issueDate"
    ></date-label>
    <div class="card-item" @click="this.articleClick">
      <div class="article-image-container">
        <div>
          <img class="article-intro-image" :src="data.article.imageUrl" />
          <img
            v-if="!data.article.isFree"
            class="vip-icon"
            :src="require('../../../../assets/imgs/collect/collect_vip.png')"
          />
          <img
            v-if="data.article.isFree"
            class="vip-icon"
            :src="require('../../../../assets/imgs/collect/collect_free.png')"
          />
        </div>
      </div>
      <div v-if="data.article.keyword" class="article-catagory">
        — {{ data.article.keyword }} —
      </div>
      <div v-if="data.article.title" class="article-desc-en">
        {{ data.article.title.replace(/&nbsp;/g, " ") }}
      </div>
      <div v-if="data.article.titleCn" class="article-desc-cn">
        {{ data.article.titleCn.replace(/&nbsp;/g, " ") }}
      </div>
      <div
        v-if="data.article.source || data.article.sourceCn"
        class="article-source"
      >
        选自<span v-if="data.article.source"
          >{{ `${data.article.source} ` }} </span
        ><span v-if="data.article.sourceCn">{{
          `(${data.article.sourceCn})`
        }}</span>
      </div>
      <div
        v-if="hasCollect != 2 ||data.article.isRead"
        class="collect-view"
        @click.stop="clickCollect"
      >
        <!-- 收藏 -->
        <div v-if="hasCollect != 2"
          class="bottom-collect-view"
        >
          <div
          class="bottom-collect"
          >
            收藏
          </div>
          <lottie
            style="position: absolute; width: 32px; left: -15px; height: 32px"
            :options="defaultOptions"
            v-on:animCreated="handleAnimation"
          />
        </div>
        <img
          v-if="data.article.isRead"
          class="icon-readed"
          :src="
            require('../../../../assets/imgs/collect/collect_readed_bottom.png')
          "
        />
      </div>
      <div v-else style="height:20px;"></div>
    </div>
  </div>
</template>

<script>
import DateLabel from "./DateLabel";
import lottie from "vue-lottie";
import Anim from "@/assets/lottie/lottie-collect.json";

export default {
  data() {
    return {
      defaultOptions: { animationData: Anim, loop: false, autoplay: false },
      defaultAnim: "",
    };
  },
  props: {
    data: {
      type: Object,
    },
    onClickCollect: {
      type: Function,
    },
    onArticleClick: {
      type: Function,
    },
    index: {
      type: Number,
    },
    hasCollect: {
      type: Number,
    },
  },
  mounted(){
    if(this.data && this.data.article.isFavorite){
      this.defaultAnim && this.defaultAnim.goToAndStop(800)
    }
  },
  watch:{
      data(val, oldVal){
        if(!this.data.article.isFavorite){
          //1 取消成功
          this.defaultAnim.stop();
        }else{
          //2 收藏成功
          this.defaultAnim.play()
        }
      },
    },
  components: {
    DateLabel,
    lottie,
  },
  methods: {
    //==============lottie================
    handleAnimation(anim) {
      this.defaultAnim = anim;

    },
    clickCollect(){
        console.log('+++===>>>clickCollect...>>>',this.data.article)
        if(this.hasCollect == 2){
          this.onArticleClick(this.data.article,this.index)
        }else{
          this.onClickCollect(this.data.article,this.index)
        }
        // let article =this.data.article
        // if (article.isFavorite) {
        //   this.defaultAnim.stop();
        //   // this.defaultAnim.goToAndPlay(100);
        // }else{
        //   this.defaultAnim.play()
        // } 
    },
    articleClick(article) {
        console.log('+++===>>>...>>>',article)
        this.onArticleClick(this.data.article,this.index)

    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container {
  padding: 0 3vw;
  display: flex;
}

.divider {
  background-color: #e3e3e3;
  height: 1px;
  width: 90%;
}

// .tab-item-text {
// color: #3994E7;
// }
.card-item {
  // background-color :
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 20px 100px 0px #d6d6d6;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.article-image-container {
  display: flex;
  position: relative;
  text-align: center;
}

.article-intro-image {
  position: relative;
  width: 100%;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.article-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12vw;
  height: 12vw;
  transform: translate(-50%, -50%);
}

.article-catagory {
  margin-top: 24px;
  font-size: 13px;
  font-weight: bold;
  color: #999999;
  font-family: serif, SimSun, STSong;
}

.article-desc-en {
  margin: 0 15px;
  margin-top: 24px;
  font-size: 14px;
  text-align: center;
  color: #333333;
  font-family: serif, SimSun, STSong;
}

.article-desc-cn {
  margin-top: 15px;
  font-size: 14px;
  color: #333333;
  font-weight: bold;
  font-family: serif, SimSun, STSong;
}

.article-source {
  margin-top: 15px;
  font-size: 11px;
  color: #999999;
  font-family: serif, SimSun, STSong;
}

.card-container {
  width: 100%;
}

.horizontal-container {
  .scroll-wrapper {
    width: 100%;
    margin: 6px auto;
    white-space: nowrap;
    overflow: hidden;

    .scroll-content {
      display: inline-block;
      vertical-align: center;
    }

    .scroll-item {
      line-height: 100%;
      font-size: 24px;
      display: inline-block;
      text-align: center;
      padding: 0 10px;
    }
  }
}

.article-collection-list-item {
  height: 82px;
  padding: 0 18px;
  display: flex;
  margin: 10px 0;
}

.article-collection-list-item-image {
  width: 82px;
  height: 82px;
  border-radius: 6px;
}

.article-collection-list-item-text-container {
  justify-content: center;
  display: flex;
  margin-left: 10px;
  flex-direction: column;
}

.article-item-title-cn {
  font-family: serif, SimSun, STSong;
  font-weight: bold;
  margin-bottom: 6px;
  font-size: 12px;
}

.article-item-title-en {
  font-family: serif, SimSun, STSong;
  font-size: 11px;
}

.article-collection-title {
  margin-top: 23px;
  font-size: 14px;
  font-weight: bold;
  color: #333333;
  font-family: serif, SimSun, STSong;
}

.article-collection-desc {
  margin-top: 20px;
  font-size: 12px;
  color: #333333;
  font-family: serif, SimSun, STSong;
}

.article-collection-tag {
  margin-top: 20px;
  font-size: 11px;
  color: #3994E7;
  font-family: serif, SimSun, STSong;
}

.article-collection-more {
  // margin: 10px 0 20px 0;
  line-height: 50px;
  color: #3994E7;
  font-size: 12px;
}

.vip-icon {
  width: 36px;
  height:16px;
  position: absolute;
  right: 15px;
  top: 15px;
}
.icon-readed {
  width: 98px;
  height: 98px;
  position: absolute;
  right: 0;
  bottom: 0px;
  border-bottom-right-radius: 16px;
}
.collect-view {
  height: 75px;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  position: relative;
}
.bottom-collect-view {
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: row;
  position: relative;
}
.bottom-collect {
  font-size: 14px;
  color: #999999;
  margin-left: 15px;
  line-height: 30px;
}
.lottie-collect {
  position: absolute;
  width: 32px; 
  left: -15px; 
  height: 32px
}
</style>


// WEBPACK FOOTER //
// app/pages/tabs/Home/component/ArticleCardItem.vue